import { Drawer, Box, Typography, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import Iconify from '../Iconify';
import Image from '../Image';
import BrandLogo from '../../assets/brand-logo.png';
import useLocales from '../../hooks/useLocales';
import NewLanguagePopover from '../../layouts/dashboard/header/NewLanguagePopover';

// reusable item
function MenuItem({ item, onClose }) {
  const { translate } = useLocales();
  const handleClick = () => {
    item.onClick?.();
    onClose?.();
  };

  return (
    <Box
      onClick={handleClick}
      display="flex"
      alignItems="center"
      gap={2}
      px={1}
      py={1.5}
      sx={{
        cursor: 'pointer',
        '&:hover': { bgcolor: '#222' },
      }}
    >
      <Iconify icon={item.icon} width={20} />
      <Typography sx={{ color: '#ADACB1' }} fontSize={'13px'}>
        {translate(item.label)}
      </Typography>
    </Box>
  );
}

// reusable section
function MenuSection({ items, onClose }) {
  return (
    <Box sx={{ bgcolor: '#1a1a1a' }}>
      {items.map((item, index) => (
        <MenuItem key={index} item={item} onClose={onClose} />
      ))}
    </Box>
  );
}

export default function MobileMenu({ open, onClose, onCloseAccDrawer }) {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const { gameCategsAndCompanies, siteSettings } = useSelector((x) => x.lookup);
  const [openLang, setOpenLang] = useState(false);

  const CATEGORY_ICON_MAP = {
    SL: 'mdi:slot-machine',
    LC: 'mdi:cards',
    FH: 'mdi:fish',
    ES: 'mdi:controller-classic-outline',
    CG: 'mdi:gamepad-variant-outline',
    IG: 'mdi:lightning-bolt-outline',
    EX: 'mdi:cricket',
    SB: 'mdi:soccer',
  };

  const dynamicGameSection =
    gameCategsAndCompanies?.map((item) => ({
      label: item.name,
      icon: CATEGORY_ICON_MAP[item.type] || 'mdi:help-circle-outline',
      onClick: () => navigate(`/arrangement/${item.slug}/${item.companies[0].id}`),
      raw: item,
    })) || [];

  const sections = [
    [
      {
        label: 'VIP',
        icon: 'mdi:crown-outline',
        onClick: () => navigate('/vip'),
      },
      {
        label: 'promotion',
        icon: 'mdi:gift-outline',
        onClick: () => navigate('/promotion/tab'),
      },
    ],
    dynamicGameSection,
    ...(siteSettings?.config_become_agent
      ? [
          [
            {
              label: 'become_agent',
              icon: 'mdi:account-tie-outline',
              onClick: () => {
                window.open(siteSettings.config_become_agent, '_blank');
              },
            },
          ],
        ]
      : []),
    [
      {
        label: 'contact_us',
        icon: 'mdi:gift-outline',
        onClick: () => navigate('/'),
      },
      {
        label: 'language',
        icon: 'mdi:translate',
        onClick: () => {
          setOpenLang(true);
        },
      },
    ],
  ];

  return (
    <>
      <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: '100%',
            height: '100%',
            bgcolor: '#111',
            color: '#fff',
            padding: 1,
          },
        }}
      >
        {/* HEADER */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={2}
          py={1.5}
          sx={{ borderBottom: '1px solid #222', backgroundColor: '#212122' }}
        >
          <Image src={BrandLogo} sx={{ width: 120 }} />

          <Box display="flex" alignItems="center" gap={1}>
            <Box
              px={1.5}
              py={0.5}
              sx={{
                bgcolor: '#212122',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate('/');
                onClose?.();
              }}
            >
              <Iconify icon="mdi:home-outline" width={18} />
              <Typography fontSize={12}>{translate('home')}</Typography>
            </Box>

            <IconButton onClick={onClose}>
              <Iconify icon="mdi:close" color="#fff" />
            </IconButton>
          </Box>
        </Box>

        <Box
          onClick={() => navigate('/referral')}
          sx={{
            mt: 1,
            p: 1.5,
            borderRadius: 0.5,
            background: 'linear-gradient(90deg, #6b3b1d 0%, #2b1a0f 100%)',
          }}
        >
          <Typography fontSize="13px">🎁 {translate('refer_and_earn')}</Typography>
        </Box>

        {/* MENU */}
        <Box mt={1} display="flex" flexDirection="column" gap={1}>
          {sections.map((section, i) => (
            <MenuSection key={i} items={section} onClose={onClose} />
          ))}
        </Box>
      </Drawer>

      <NewLanguagePopover open={openLang} handleOpen={openLang} handleClose={() => setOpenLang(false)} />
    </>
  );
}
